import * as React from 'react';
import { Content } from '../../interfaces';

const ContentContext = React.createContext({} as Content);

export default ContentContext;



// WEBPACK FOOTER //
// ./src/components/App/Context.tsx